export default "__VITE_ASSET__CNFlP9Cz__"